import { render, staticRenderFns } from "./BaseRadioCheckBox.vue?vue&type=template&id=73dd2c27&scoped=true"
import script from "./BaseRadioCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseRadioCheckBox.vue?vue&type=script&lang=js"
import style0 from "./BaseRadioCheckBox.vue?vue&type=style&index=0&id=73dd2c27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dd2c27",
  null
  
)

export default component.exports